import { Api } from './Api'

class CustomElementContent {
  getPromise (ocr, preview = '0') {
    if (preview === '1') {
      return fetch(`${Api.getBaseUrl()}customelementcontent/${ocr}?preview=1`, Api.getOptions())
    } else {
      return fetch(`${Api.getBaseUrl()}customelementcontent/${ocr}`, Api.getOptions())
    }
  }
}

export default CustomElementContent
